import { useMutation } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'

import type { PublicUserData } from '../../schemas/user'

interface ProfessionalStartJourneyRequest {
  firstName: string
  lastName: string
  createdByUserId: number
  phoneNumber: string
}

export const professionalStartJourney = async (requestBody: ProfessionalStartJourneyRequest) => {
  const response = await postRequest<PublicUserData>('/consumers/start-journey', requestBody)
  return response
}

export const useProfessionalStartJourney = () => {
  return useMutation({
    mutationFn: professionalStartJourney,
  })
}
